import { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import Helmetcomponent from "../../Components/Helmet/helmetcomponent";
import httpService from "../../common/http.service";
import { useNavigate } from "react-router-dom";

const DeleteForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    feedback: "",
  });
  const [captchaValue, setCaptchaValue] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const validateForm = () => {
    const { email, phoneNumber } = formData;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    if (!phoneRegex.test(phoneNumber)) {
      toast.error("Please enter a valid 10-digit phone number starting with 6-9.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!captchaValue) {
        toast.error("Please verify captcha to submit the form");
        return;
      }

      if (!validateForm()) {
        return;
      }

      const res = await httpService.post(`account/contactEmail`, {
        ...formData,
        delete: true,
      });
      if (res.status === 200) {
        toast.success("Your message has been sent successfully. We'll get back to you soon");
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          feedback: "",
        });
        setTimeout(() => {
          navigate("/");
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  document.title = "BharatCalendars - Delete User";

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "start",
        textAlign: "justify",
        fontSize: "1.2rem",
        padding: "0.5rem",
      }}
    >
      <Helmetcomponent index={"DeleteUser"} path={""} data={""} />
      <Container>
        <h1 style={{ color: "#f16334", fontFamily: "fantasy", textAlign: "center", fontSize: "2rem", margin: "1rem 0rem" }}>
          Request Account Deletion
        </h1>
        <Row className="justify-content-center">
          <Col md={5} style={{ border: "1px solid #f16334", padding: "1rem", borderRadius: "10px", gap: "1rem" }}>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="name" placeholder="Enter your name" value={formData.name} onChange={handleChange} required />
              </Form.Group>

              <Form.Group controlId="formEmail" className="mt-2">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} required />
              </Form.Group>

              <Form.Group controlId="formPhoneNumber" className="mt-2">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  name="phoneNumber"
                  placeholder="Enter your phone number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="formFeedback" className="mt-2">
                <Form.Label>Feedback</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="feedback"
                  placeholder="Enter feedback"
                  value={formData.feedback}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <div className="text-center">
                <Form.Group controlId="formCaptcha" className="my-3">
                  <ReCAPTCHA sitekey="6Le27NUpAAAAAIGMdi_4CLWBlnKfe8WZUBuut-X1" onChange={handleCaptchaChange} />
                </Form.Group>
              </div>

              <div className="text-center">
                <Button variant="primary" type="submit" disabled={!captchaValue}>
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DeleteForm;
